import {Component, OnInit} from '@angular/core';

import {AlertService, AuthenticationService, ProjectService} from '../../_services/index';

import {ActivatedRoute, Router} from '@angular/router';

import {Project, User} from '../../_models/index';
import {LoginHelper} from '../../helpers';

@Component({
    standalone: false,
  selector: "cidreport-component",
  templateUrl: 'sharedResponsibilityReport.component.html',
  styleUrls: ['./sharedResponsibilityReport.component.scss'],
})

export class SharedResponsibilityReportComponent implements OnInit {
  items: any[] = [];
  currentUser: User;
  projectId: number;
  tenantName: string;
  date = new Date();
  public project: Project;

  cols : any[] = [
    {'field': 'vendor', 'header': 'Vendor'},
    {'field': 'service', 'header': 'Service'},
    {'field': 'responsibility', 'header': 'Responsibility'},
    {'field': 'controls', 'header': 'Control Items'},
  ]

  constructor(
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public alertService: AlertService) {

    this.projectId = route.snapshot.params['projectId'];
  }

  ngOnInit() {
    const tenantName = this.tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.loadData();
  }

  public loadData() {

    this.projectService.getById(this.projectId).subscribe(p => this.project = p);

    this.projectService.getServicesReport(this.projectId)
      .subscribe(items => {
          this.items = items;
        },

        error => {
          const errorMessage = 'An error occurred while loading projects.';
          this.alertService.error(errorMessage);
        });
  }
}
